export default function SupplierCommissionManagement() {

  return (
      <p>مدیریت کمیسیون تأمین کننده</p>
  );
};